import { gql } from '@apollo/client';

const UPDATE_USER_AVATAR = gql`
  mutation UpdateUser($avatar: String, $userId: ID!) {
    updateUser(avatar: $avatar, userId: $userId) {
      user {
        avatar
      }
    }
  }
`;

export default UPDATE_USER_AVATAR;
